<template>
  <div
    class="row position-relative mt-1"
    style="margin-bottom: 8em;"
    :style="{'top': topOffset}">
    <div
      v-if="loading"
      class="col-12 text-center mt-5">
      <Spinner/>
    </div>
    <template
      class="col-12"
      v-else>
      <div
        class="row"
        v-if="products.length">
        <div
          v-for="(p, i) in products"
          class="col-xxl-2 col-xl-3 col-md-4 col-sm-6 my-2">
          <DataLoader
            :index="i"
            :key="i + dataLoaderKey"
            :loadInterval="loadInterval"
            :id="'dataLoader' + '-' + 'list' + '-'+ i"
            @getData="getData"/>
          <ProductCard
            :key="p.product_id"
            :env="env"
            :product="p"
            :mfg="mfg"/>
        </div>
      </div>
      <div
        v-else
        class="col-12 text-center mt-5">
        <h4 class="text-muted">No Data</h4>
      </div>
    </template>
  </div>
</template>

<script setup>
  import ProductCard from './ProductCard.vue';
  import Spinner from '../../../../../global/Spinner.vue';
  import { inject , onMounted, ref, computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { useStore } from 'vuex';
  import DataLoader from 'components/private/views/product/DataLoader.vue';

  // Lifecycle
  onMounted(()=>{
    document.addEventListener('resize', ()=>{
      offSet()
    })
    offSet()
  })

  // Initialize
  const props = defineProps(['query', 'products', 'loading', 'mfg', 'condense'])
  const env = inject('env')
  const loadInterval = 24
  const store = useStore()
  const route = useRoute()

  // Data
  const topOffset = ref(null)

  // Methods
  const offSet = ()=>{
    const subNav = document.getElementById('dropshipMfgHeader')
     topOffset.value = subNav.clientHeight + 45 + 'px'
  }

  const getData = (index)=>{
    let products
    if(index == 0){
      products = _.slice(props.products, index, loadInterval)
    }else{
      products = _.slice(props.products, index + 1, loadInterval + (index + 1))
    }
    products = _.map(products, 'product_id')
    if(products?.length){
      store.dispatch('getProductData', {route: route.path, products, price_type: props.mfg.details.price_type.id})
    }
  }

  // Computed
  const windowSize = computed(()=>{
    return window.innerHeight + window.innerWidth
  })

  const dataLoaderKey = computed(()=>{
    return ('-' + props.products.length + '-' + windowSize.value).toString()
  })
</script>